import type { McpServerDefinition } from "@/api/mock-data/agent-estate/seed";

type Tool = McpServerDefinition["tools"][number];

const read = (name: string, dataAccess: string): Tool => ({
  name,
  classification: "Read",
  dataAccess,
});
const write = (name: string, dataAccess: string): Tool => ({
  name,
  classification: "Write",
  dataAccess,
});

/**
 * The customer-support MCP servers. Investment Banking profile only: the
 * shared `MCP_SERVER_CATALOG` backs the non-IB estate's exact-count specs, so
 * these are appended through `getMcpServerCatalog()` rather than added there.
 */
export const DEMO_MCP_SERVER_CATALOG: McpServerDefinition[] = [
  {
    id: "mcp-sharepoint-support",
    name: "SharePoint MCP",
    technology: "SharePoint",
    businessUnits: ["CUSTOMER_SUPPORT"],
    capabilities: [
      "Search and read support knowledge articles",
      "Read case attachments",
    ],
    tools: [
      read("searchSites", "Support knowledge"),
      read("searchDocuments", "Support knowledge"),
      read("getDocument", "Support knowledge"),
      read("listLibraries", "Support knowledge"),
      read("listFolderContents", "Support knowledge"),
      read("readTextFile", "Support knowledge"),
      read("getFileMetadata", "Support knowledge"),
      read("getVersionHistory", "Support knowledge"),
      read("getSensitivityLabel", "Support knowledge"),
      read("listCaseAttachments", "Case attachments"),
      write("uploadCaseAttachment", "Case attachments"),
      write("shareDocumentLink", "Support knowledge"),
    ],
  },
  {
    id: "mcp-servicenow-support",
    name: "ServiceNow MCP",
    technology: "ServiceNow",
    businessUnits: ["CUSTOMER_SUPPORT"],
    capabilities: ["Read and triage service tickets", "Update ticket state"],
    tools: [
      read("searchIncidents", "Service tickets"),
      read("getIncident", "Service tickets"),
      read("listIncidentComments", "Service tickets"),
      read("searchKnowledgeBase", "Support knowledge"),
      read("getCaseHistory", "Case history"),
      read("getAssignmentGroup", "Service tickets"),
      write("updateIncident", "Service tickets"),
      write("addWorkNote", "Service tickets"),
    ],
  },
  {
    id: "mcp-salesforce-support",
    name: "Salesforce MCP",
    technology: "Salesforce",
    businessUnits: ["CUSTOMER_SUPPORT"],
    capabilities: ["Read customer accounts and cases", "Log interactions"],
    tools: [
      read("searchAccounts", "Customer accounts"),
      read("getAccount", "Customer accounts"),
      read("getContact", "Customer contacts"),
      read("searchCases", "Customer cases"),
      read("getCase", "Customer cases"),
      read("listCaseComments", "Customer cases"),
      read("getEntitlements", "Customer accounts"),
      write("logInteraction", "Customer cases"),
    ],
  },
];
